var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgControlLoopCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9457_42365",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.45277 4.07989L8.53271 3.6196L9.41934 1.84686C9.59236 1.4973 9.94936 1.27679 10.3394 1.27858H12.0787V2.30715H10.3394C10.3394 2.30715 9.45277 4.07989 9.45277 4.07989Z",
    fill: "url(#paint0_linear_9457_42365)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1073 3.33571C12.2567 3.33571 11.5645 2.64349 11.5645 1.79286C11.5645 0.942228 12.2567 0.25 13.1073 0.25C13.9579 0.25 14.6502 0.942228 14.6502 1.79286C14.6502 2.64349 13.9579 3.33571 13.1073 3.33571ZM13.1073 1.27857C12.8233 1.27857 12.593 1.50883 12.593 1.79286C12.593 2.07689 12.8233 2.30714 13.1073 2.30714C13.3913 2.30714 13.6216 2.07689 13.6216 1.79286C13.6216 1.50883 13.3913 1.27857 13.1073 1.27857Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44723 10.8201L6.36729 11.2804L5.48066 13.0532C5.30764 13.4027 4.95064 13.6232 4.5606 13.6214H2.82129V12.5929H4.5606C4.5606 12.5929 5.44723 10.8201 5.44723 10.8201Z",
    fill: "url(#paint1_linear_9457_42365)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.79286 11.5643C2.64349 11.5643 3.33571 12.2565 3.33571 13.1071C3.33571 13.9578 2.64349 14.65 1.79286 14.65C0.942228 14.65 0.25 13.9578 0.25 13.1071C0.25 12.2565 0.942228 11.5643 1.79286 11.5643ZM1.79286 13.6214C2.07689 13.6214 2.30714 13.3912 2.30714 13.1071C2.30714 12.8231 2.07689 12.5928 1.79286 12.5928C1.50883 12.5928 1.27857 12.8231 1.27857 13.1071C1.27857 13.3912 1.50883 13.6214 1.79286 13.6214Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45277 10.8201L8.53271 11.2804L9.41934 13.0532C9.59236 13.4027 9.94936 13.6232 10.3394 13.6214H12.0787V12.5929H10.3394L9.45277 10.8201Z",
    fill: "url(#paint2_linear_9457_42365)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6502 13.1071C14.6502 13.9578 13.9579 14.65 13.1073 14.65C12.2567 14.65 11.5645 13.9578 11.5645 13.1071C11.5645 12.2565 12.2567 11.5643 13.1073 11.5643C13.9579 11.5643 14.6502 12.2565 14.6502 13.1071ZM13.6216 13.1071C13.6216 12.8231 13.3913 12.5928 13.1073 12.5928C12.8233 12.5928 12.593 12.8231 12.593 13.1071C12.593 13.3912 12.8233 13.6214 13.1073 13.6214C13.3913 13.6214 13.6216 13.3912 13.6216 13.1071Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50143 4.07989L6.42149 3.6196L5.53486 1.84686C5.36184 1.4973 5.00484 1.27679 4.6148 1.27858H2.87549V2.30715H4.6148C4.6148 2.30715 5.50143 4.07989 5.50143 4.07989Z",
    fill: "url(#paint3_linear_9457_42365)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 1.79286C0.25 0.942228 0.942228 0.25 1.79286 0.25C2.64349 0.25 3.33571 0.942228 3.33571 1.79286C3.33571 2.64349 2.64349 3.33571 1.79286 3.33571C0.942228 3.33571 0.25 2.64349 0.25 1.79286ZM1.27857 1.79286C1.27857 2.07689 1.50882 2.30714 1.79286 2.30714C2.07689 2.30714 2.30714 2.07689 2.30714 1.79286C2.30714 1.50883 2.07689 1.27857 1.79286 1.27857C1.50882 1.27857 1.27857 1.50883 1.27857 1.79286Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9457_42365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.77832 -0.778564H15.6788V15.6786H-0.77832V-0.778564Z",
    fill: "#0550DC"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44974 4.3643C9.15099 4.3643 10.5354 5.74875 10.5354 7.45001C10.5354 9.15127 9.15099 10.5357 7.44974 10.5357C5.74848 10.5357 4.36402 9.15127 4.36402 7.45001C4.36402 5.74875 5.74848 4.3643 7.44974 4.3643ZM7.44974 3.33572C5.17748 3.33572 3.33545 5.17775 3.33545 7.45001C3.33545 9.72227 5.17748 11.5643 7.44974 11.5643C9.72199 11.5643 11.564 9.72227 11.564 7.45001C11.564 5.17775 9.72199 3.33572 7.44974 3.33572Z",
    fill: "#0550DC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93801 7.54152L6.13521 6.70735L5.39258 7.44998L6.93544 8.99283L9.50686 6.42141L8.78172 5.67929L6.93801 7.54152Z",
    fill: "#0550DC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9457_42365",
    x1: 9.84709,
    y1: 4.22341,
    x2: 11.0546,
    y2: 0.905827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9457_42365",
    x1: 5.1742,
    y1: 10.6928,
    x2: 3.63244,
    y2: 13.9996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9457_42365",
    x1: 9.7258,
    y1: 10.6928,
    x2: 11.2676,
    y2: 13.9996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9457_42365",
    x1: 5.22842,
    y1: 4.20718,
    x2: 3.68662,
    y2: 0.900386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlLoopCard);
export default __webpack_public_path__ + "static/media/ControlLoopCard.7333f94650e72de4463cb812431091bf.svg";
export { ForwardRef as ReactComponent };